import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import { Paper, FormControl, TextField, FormLabel, FormGroup, FormControlLabel, Checkbox, Typography, IconButton } from '@material-ui/core';
import { format, parse } from 'date-fns';
import IntegrationAutosuggest from '../share/IntegrationAutosuggest';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import ProfissionalService from '../../services/ProfissionalService';
import VariantSnackbar from '../share/VariantSnackbar';

const styles = theme => ({
  paper: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
  textFieldDe: {
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit,
    marginBottom: theme.spacing.unit * 1,
    width: 340,
  },
  textFieldAte: {
    marginLeft: theme.spacing.unit * 4,
    marginRight: theme.spacing.unit,
    marginBottom: theme.spacing.unit * 1,
    width: 340,
  },
  formControlAutoCompletePrestador: {
    margin: theme.spacing.unit,
    minWidth: 650,
  },
  formLabelEspecialidadeNaoVinculada: {
    display: 'inline',
    marginTop: theme.spacing.unit,
    marginLeft: theme.spacing.unit
  },
  formControlSelectEspecialidadeNaoVinculada: {
    marginTop: theme.spacing.unit,
    margin: theme.spacing.unit,
    marginLeft: theme.spacing.unit,
    minWidth: 50,
    display: 'inline'
  },
  paperEspecialidadeNaoVinculada: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 1,
    paddingBottom: theme.spacing.unit * 1,
    margin: theme.spacing.unit * 1,
    marginTop: theme.spacing.unit * 1,
    overflow: 'auto',
    maxHeight: '35vh',
    height: '35vh',
    width: 345,
  },
  divButtons: {
    marginTop: theme.spacing.unit * 15,
    display: 'inline-grid',
  },
  formLabelEspecialidade: {
    display: 'inline',
    marginTop: theme.spacing.unit,
    marginLeft: theme.spacing.unit
  },
  formControlSelectEspecialidade: {
    marginTop: theme.spacing.unit,
    margin: theme.spacing.unit,
    minWidth: 50,
    display: 'inline'
  },
  paperEspecialidade: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 1,
    paddingBottom: theme.spacing.unit * 1,
    margin: theme.spacing.unit * 1,
    marginTop: theme.spacing.unit * 1,
    overflow: 'auto',
    maxHeight: '35vh',
    height: '35vh',
    width: 345,
  },
});
class FormDialogPrestadorEspecialidades extends React.Component {
  profissionalService = new ProfissionalService();
  state = {
    ...this.props.profissionalPrestador,
    from: this.props.modoInclusao ? format(new Date(), 'YYYY-MM-DD') : this.props.profissionalPrestador.dtaInicio,
    to: this.props.modoInclusao ? null : this.props.profissionalPrestador.dtaFim,
    especialidades: this.props.especialidades,
    especialidadesSelected: [],
    especialidadesSelectedComNome: [],
    especialidadesNaoVinculadas: [],
    especialidadesNaoVinculadasSelected: [],
    especialidadesNaoVinculadasSelectedComNome: [],
    seqPrestadorSelected: this.props.modoInclusao ? 0 : this.props.profissionalPrestador.seqPrestador,
    nomePrestadorSelected: this.props.modoInclusao ? 0 : this.props.profissionalPrestador.nomePrestador,
    errorDataToMessage: '',
    modoInclusao: this.props.modoInclusao,
    snackOpen: false,
    snackMessage: '',
    sucesso: false,
    desEspecialidadesPermitidas: '',
  }

  componentDidMount = async () => {
    let especialidades = await this.profissionalService.consultarEspecialidades();
    this.setState({ especialidades: especialidades });
    if (!this.state.modoInclusao) {
      let especialidadesNaoVinculadasSelected = this.state.especialidadesNaoVinculadasSelected;
      let especialidadesNaoVinculadasSelectedComNome = this.state.especialidadesNaoVinculadasSelectedComNome;
      var especialidadesSelected = this.state.desEspecialidades.split(',');
      for (var i = 0; i < especialidadesSelected.length; i++) {
        let codEspecialidade = especialidadesSelected[i].substring(0, especialidadesSelected[i].indexOf('-') - 1).trim();
        let nomeEspecialidade = especialidadesSelected[i].substring(especialidadesSelected[i].indexOf('-') + 1).trim();
        especialidadesNaoVinculadasSelected.push(Number(codEspecialidade));
        especialidadesNaoVinculadasSelectedComNome.push({id: Number(codEspecialidade), nome: codEspecialidade + ' - ' + nomeEspecialidade});
      }
      this.setState({ especialidadesNaoVinculadasSelected: especialidadesNaoVinculadasSelected,
        especialidadesNaoVinculadasSelectedComNome: especialidadesNaoVinculadasSelectedComNome });
      this.vincularEspecialidades();
    }
  }

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  }

  getSuggestionValuePrestador = (suggestion, id) => {
    this.setState({
      seqPrestadorSelected: id !== undefined ? id : suggestion.id,
      nomePrestadorSelected: suggestion,
    });
    return suggestion.nome;
  }

  handleChangeCheckBoxNaoVinculados = event => {
    let especialidadesNaoVinculadasSelected = this.state.especialidadesNaoVinculadasSelected;
    let especialidadesNaoVinculadasSelectedComNome = this.state.especialidadesNaoVinculadasSelectedComNome;
    if (event.target.checked) {
      especialidadesNaoVinculadasSelected.push(Number(event.target.id));
      especialidadesNaoVinculadasSelectedComNome.push({id: Number(event.target.id), nome: event.target.name});
    } else {
      var index = especialidadesNaoVinculadasSelected.indexOf(Number(event.target.id));
      especialidadesNaoVinculadasSelected.splice(index, 1);
      especialidadesNaoVinculadasSelectedComNome.splice(index, 1);
    }
    this.setState({ especialidadesNaoVinculadasSelected: especialidadesNaoVinculadasSelected,
      especialidadesNaoVinculadasSelectedComNome: especialidadesNaoVinculadasSelectedComNome });
  }

  handleChangeCheckBoxVinculados = event => {
    let especialidadesSelected = this.state.especialidadesSelected;

    if (event.target.checked) {
      especialidadesSelected.push(Number(event.target.id));
    } else {
      var index = especialidadesSelected.indexOf(Number(event.target.id));
      especialidadesSelected.splice(index, 1);
    }
    this.setState({ especialidadesSelected: especialidadesSelected.sort() });
  }

  vincularEspecialidades = async () => {
    let especialidades = this.state.especialidades;
    let especialidadesSelectedComNome = this.state.especialidadesSelectedComNome;
    for (var i = 0; i < this.state.especialidadesNaoVinculadasSelected.length; i++) {
      for (var j = 0; j < this.state.especialidades.length; j++) {
        if (this.state.especialidadesNaoVinculadasSelected[i] === this.state.especialidades[j].id) {
          especialidades.splice(j, 1);
        }
      }
    }
    this.setState({ especialidadesSelected: [],
      especialidadesSelectedComNome: especialidadesSelectedComNome.concat(this.state.especialidadesNaoVinculadasSelectedComNome),
      especialidades: especialidades,
      especialidadesNaoVinculadasSelected: [],
      especialidadesNaoVinculadasSelectedComNome: [] });
  }

  desvincularEspecialidades = async () => {
    let especialidades = Array.from(this.state.especialidades);
    let especialidadesSelected = Array.from(this.state.especialidadesSelected);
    especialidadesSelected = especialidadesSelected.sort();
    let especialidadesSelectedComNome = Array.from(this.state.especialidadesSelectedComNome);
    let lenEspecialidadesSelected = especialidadesSelected.length;
    let lenEspecialidadesSelectedComNome = especialidadesSelectedComNome.length;
    let i = 0;
    let j = 0;
    for (i = 0; i < lenEspecialidadesSelectedComNome; i++) {
      for (j = 0; j < lenEspecialidadesSelected; j++) {
        if (especialidadesSelectedComNome[i].id === especialidadesSelected[j]) {
          especialidades.push({id: Number(this.state.especialidadesSelectedComNome[i].id), nome: this.state.especialidadesSelectedComNome[i].nome});
        }
      }
    }
    i = 0;
    j = 0;
    for (i = 0; i < lenEspecialidadesSelected; i++) {
      j = especialidadesSelectedComNome.findIndex(x => x.id === this.state.especialidadesSelected[i]);
      especialidadesSelectedComNome.splice(j, 1);
    }
    especialidades = especialidades.sort(this.dynamicSort('id'));
    this.setState({ especialidadesSelected: [],
      especialidadesSelectedComNome: especialidadesSelectedComNome,
      especialidades: especialidades.sort(this.dynamicSort('id')),
      especialidadesNaoVinculadasSelected: [],
      especialidadesNaoVinculadasSelectedComNome: [] });
  }

  dynamicSort (property) {
    var sortOrder = 1;
    if (property[0] === '-') {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
      return result * sortOrder;
    };
  }

  handleClose = () => {
    let especialidades = Array.from(this.state.especialidades);
    let especialidadesSelectedComNome = Array.from(this.state.especialidadesSelectedComNome);
    let lenEspecialidadesSelectedComNome = especialidadesSelectedComNome.length;
    let i = 0;
    for (i = 0; i < lenEspecialidadesSelectedComNome; i++) {
      especialidades.push({id: Number(this.state.especialidadesSelectedComNome[i].id), nome: this.state.especialidadesSelectedComNome[i].nome});
    }
    this.setState({ especialidades: especialidades.sort(this.dynamicSort('id')),
      especialidadesSelected: [],
      especialidadesSelectedComNome: [],
      especialidadesNaoVinculadas: [],
      especialidadesNaoVinculadasSelected: [],
      especialidadesNaoVinculadasSelectedComNome: [] });
    this.props.handleClose();
  }

  handleClickSave = async () => {
    let especialidades = Array.from(this.state.especialidades);
    let especialidadesSelectedComNome = Array.from(this.state.especialidadesSelectedComNome);
    let lenEspecialidadesSelectedComNome = especialidadesSelectedComNome.length;
    let i = 0;
    for (i = 0; i < lenEspecialidadesSelectedComNome; i++) {
      especialidades.push({id: Number(this.state.especialidadesSelectedComNome[i].id), nome: this.state.especialidadesSelectedComNome[i].nome});
    }

    this.setState({ especialidades: especialidades.sort(this.dynamicSort('id')),
      especialidadesSelected: [],
      especialidadesSelectedComNome: [],
      especialidadesNaoVinculadas: [],
      especialidadesNaoVinculadasSelected: [],
      especialidadesNaoVinculadasSelectedComNome: [] });

    i = 0;
    var desEspecialidades = '';
    for (i = 0; i < this.state.especialidadesSelectedComNome.length; i++) {
      desEspecialidades = desEspecialidades + this.state.especialidadesSelectedComNome[i].nome + ', ';
    }
    desEspecialidades = desEspecialidades.substring(0, desEspecialidades.length - 2);
    const profPrestador = [this.state.seqRegistroPrestador === null || this.state.seqRegistroPrestador === undefined ? 0 : this.state.seqRegistroPrestador,
      this.state.seqPrestadorSelected,
      this.state.nomePrestadorSelected,
      this.state.from === '' || this.state.from === null || this.state.from === undefined ? parse(new Date(0)) : parse(this.state.from),
      this.state.to === '' || this.state.to === null || this.state.to === undefined ? null : parse(this.state.to),
      desEspecialidades,
      ''];
    var errorMessageTo = '';
    errorMessageTo = this.profissionalService.validarDataFim(
      this.state.to === '' || this.state.to === null || this.state.to === undefined ? parse(new Date(0)) : parse(this.state.to),
      this.state.from === '' || this.state.from === null || this.state.from === undefined ? parse(new Date(0)) : parse(this.state.from)
    );
    if (errorMessageTo === '') {
      let especialidadesPermitidas = await this.profissionalService.consultarEspecialidadesPermitidas(this.state.seqPrestadorSelected);
      if (
        (this.state.to !== '' && this.state.to !== null && this.state.to !== undefined) ||
         !this.validarEspecialidadesPermitidas(especialidadesPermitidas, especialidadesSelectedComNome)
      ) {
        this.props.handleSave(profPrestador);
      } else {
        this.setState({
          snackOpen: true,
          sucesso: false,
          snackMessage: 'As especialidades do profissional não podem ser atendidas neste prestador. Especialidades do prestador: ' +
                        this.state.desEspecialidadesPermitidas });
      }
    } else {
      this.setState({errorDataToMessage: errorMessageTo});
    }
  }

  validarEspecialidadesPermitidas = (especialidadesPermitidas, especialidadesSelectedComNome) => {
    let achouEspecialidadeNaoPermitida = false;
    let j = 0;
    let desEspecialidades = '';
    for (let i = 0; i < especialidadesSelectedComNome.length; i++) {
      j = especialidadesPermitidas.findIndex(x => x.id === especialidadesSelectedComNome[i].id);
      if (j === -1) {
        achouEspecialidadeNaoPermitida = true;
        break;
      }
    }
    for (let i = 0; i < especialidadesPermitidas.length; i++) {
      desEspecialidades = desEspecialidades + especialidadesPermitidas[i].nome + ', ';
    }
    desEspecialidades = desEspecialidades.substring(0, desEspecialidades.length - 2);
    this.setState({desEspecialidadesPermitidas: desEspecialidades});
    return achouEspecialidadeNaoPermitida;
  }

  handleCloseSnackbar = () => {
    this.setState({ snackOpen: false });
  }

  isSalvarDisabled = () => {
    return (this.state.seqPrestadorSelected === 0 ||
    this.state.from === '' ||
    (this.state.especialidadesSelectedComNome.length === 0 && this.state.modoInclusao));
  }

  render () {
    const { classes, open, titulo, prestadores } = this.props;
    const { from, to, especialidadesSelected, especialidades,
      especialidadesNaoVinculadasSelected, especialidadesSelectedComNome } = this.state;
    return (
      <div>
        <Dialog
          disableBackdropClick
          maxWidth='md'
          fullWidth
          open={open}
          onClose={this.handleClose}
        >
          <DialogTitle>{titulo}</DialogTitle>
          <DialogContent>
            <Paper className={classes.paper}>
              <FormControl className={classes.formControlAutoCompletePrestador}>
                <IntegrationAutosuggest
                  getSuggestionValue={this.getSuggestionValuePrestador}
                  suggestions={prestadores}
                  maxSuggestions={6}
                  // idSelected={this.state.modoInclusao === false ? this.state.seqPrestador : 0}
                  // nomeSelected={this.state.modoInclusao === false ? this.state.nomePrestador : ''}
                  idSelected={this.state.seqPrestador}
                  nomeSelected={this.state.nomePrestador}
                  placeholder={'Digite o nome do prestador...'} />
              </FormControl>
              <TextField
                label='De'
                id='date'
                type='date'
                value={from}
                onChange={this.handleChange}
                inputProps={{
                  name: 'from',
                }}
                className={classes.textFieldDe}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <TextField
                id='date'
                error={this.state.errorDataToMessage !== ''}
                label={this.state.errorDataToMessage !== '' ? this.state.errorDataToMessage : 'Até'}
                className={classes.textFieldAte}
                type='date'
                value={to}
                onChange={this.handleChange}
                inputProps={{
                  name: 'to',
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Paper>
            <Paper style={{display: 'inline-flex'}}>
              <FormControl className={classes.formControlSelectEspecialidadeNaoVinculada}>
                <FormLabel component='legend' className={classes.formLabelEspecialidadeNaoVinculada}>Especialidades Não Vinculadas:</FormLabel>
                <Paper className={classes.paperEspecialidadeNaoVinculada}>
                  <FormGroup>
                    {especialidades.length > 0
                      ? especialidades.map((especialidade, idx) => (
                        <FormGroup key={idx}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={especialidadesNaoVinculadasSelected.includes(especialidade.id)}
                                key={idx}
                                name={especialidade.nome}
                                id={especialidade.id.toString()}
                                onChange={this.handleChangeCheckBoxNaoVinculados}
                                value={especialidade.nome} />
                            }
                            label={especialidade.nome}
                          />
                        </FormGroup>
                      ))
                      : <Typography>Especialidades Não Encontradas</Typography>}
                  </FormGroup>
                </Paper>
              </FormControl>
              <div className={classes.divButtons}>
                <IconButton
                  size='small'
                  color='primary'
                  disabled={especialidadesNaoVinculadasSelected.length === 0}
                  title='Vincular Especialidades'
                  onClick={this.vincularEspecialidades}>
                  <ChevronRight />
                </IconButton>
                <IconButton
                  size='small'
                  color='primary'
                  disabled={especialidadesSelected.length === 0}
                  title='Desvincular Especialidades'
                  onClick={this.desvincularEspecialidades}>
                  <ChevronLeft />
                </IconButton>
              </div>
              <FormControl className={classes.formControlSelectEspecialidade}>
                <FormLabel component='legend' className={classes.formLabelEspecialidade}>Especialidades no Prestador:</FormLabel>
                <Paper className={classes.paperEspecialidade}>
                  <FormGroup>
                    {especialidadesSelectedComNome.length > 0
                      ? especialidadesSelectedComNome.map((especialidade, idx) => (
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={especialidadesSelected.includes(especialidade.id)}
                                key={idx}
                                name={especialidade.nome}
                                id={especialidade.id.toString()}
                                onChange={this.handleChangeCheckBoxVinculados}
                                value={especialidade.nome} />
                            }
                            label={especialidade.nome}
                          />
                        </FormGroup>
                      ))
                      : <Typography>Prestador sem Especialidades cadastradas</Typography>}
                  </FormGroup>
                </Paper>
              </FormControl>
            </Paper>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color='primary' id={'fechar'}>
              Fechar
            </Button>
            <Button
              disabled={this.isSalvarDisabled()}
              onClick={this.handleClickSave}
              color='primary'>
              Salvar
            </Button>
          </DialogActions>
        </Dialog>
        <VariantSnackbar
          vertical={'top'}
          horizontal={'right'}
          variant={this.state.sucesso ? 'success' : 'error'}
          message={this.state.snackMessage}
          open={this.state.snackOpen}
          handleClose={this.handleCloseSnackbar} />
      </div>
    );
  }
}
export default withStyles(styles)(FormDialogPrestadorEspecialidades);
